// extracted by mini-css-extract-plugin
export default {"input":"input_input__gZUrL","label":"input_label__xCK9R","xs":"input_xs__fMY83","small":"input_small__ML397","large":"input_large__tV+gf"};